import React from 'react'
import { useTranslation } from 'react-i18next'
import ScoutText from '../../../../../../common/display/scoutText/ScoutText'
import { DescriptionFieldProps } from '../../../../../../../@types/types'
import { DescriptionScreenValidationResult } from '../../../../../../../@types/validation-types'
import TextArea from '../../../../../../common/inputs/textArea/TextArea'
import { isWebView } from '../../../../../../../utils/navigation'

export const AdDescription: React.FC<DescriptionFieldProps<DescriptionScreenValidationResult>> = ({
  insertionData,
  validationMessages,
  screenName,
  showDescriptionSubtitle,
  onChange,
  onHandleDescriptionChange,
  initialPlaceholder = ['wizard.screen.description.adDescriptionPlaceholder', 'eg. old building.'],
}) => {
  const { t } = useTranslation()
  const isWebViewSet = isWebView()
  const descriptionLabel = isWebViewSet
    ? t('wizard.screen.description.mobile.adDescription')
    : t('wizard.screen.description.adDescription')
  const labelPlaceholder = t(initialPlaceholder)

  return (
    <div className='grid-item margin-top-m'>
      <TextArea
        id='ad-description'
        name='adDescription'
        rows={8}
        placeholder={labelPlaceholder}
        allowResize={true}
        errors={validationMessages!.adDescription ?? []}
        value={insertionData.adDescription}
        label={showDescriptionSubtitle ? <ScoutText label={descriptionLabel} /> : descriptionLabel}
        showMaxLengthLabel={true}
        maxLength={2000}
        onChange={(property, value) => {
          onChange({ screen: screenName, property }, value)
          onHandleDescriptionChange && onHandleDescriptionChange()
        }}
      />
    </div>
  )
}
